import Cookies from 'js-cookie';

import { StoredTokens } from '@/types/auth.types';
import { removeStorageItem } from '../storage/local-storage';

export const clearPreSignoutItems = () => {
  removeStorageItem(StoredTokens.storedTwoFactor);
  removeStorageItem('currentChannel');
  removeStorageItem('admin_SSO_access');
  removeStorageItem('sso_admin_auth');
  removeStorageItem('auth_email');
};

export const clearPostSignoutItems = () => {
  removeStorageItem(StoredTokens.currentUser);
  Cookies.remove('refreshToken');
  Cookies.remove('accessToken');
};
